import { IconButton, makeStyles } from '@material-ui/core'
import React from 'react'
import { getJackpotErrors, useGetJackpotQuery, useChangeJackpotMutation } from '../../../api/jackpot'
import JackpotError from '../error'
import JackpotForm from '../Form'
import CloseIcon from '@material-ui/icons/Close'
import { Wrapper } from './styles'
import { useSelector } from 'react-redux'
import Preloader from '../../Common/Preloader'
import { authSelector } from '../../../redux/authReducer'

const useStyles = makeStyles(() => ({
  closeBtn: {
    position: 'absolute',
    top: '0',
    right: '0',
  },
}))

interface changeJackpotProps {
  jackpotId: number
  hall_id?: null | number
  table_id?: number
  hideChangeJackpot: () => void
}

const ChangeJackpot: React.FC<changeJackpotProps> = ({
  jackpotId,
  hall_id,
  table_id,
  hideChangeJackpot,
}) => {
  const classes = useStyles()
  
  const { currentData: jackpot, isLoading: loading, error: loadError } = useGetJackpotQuery(jackpotId, { skip: !jackpotId })
  const [changeJackpot, { isLoading: saving, error }] = useChangeJackpotMutation()
  const { role: { item: userRole } } = useSelector(authSelector);

  return (
    <Wrapper>
      <IconButton className={classes.closeBtn} onClick={hideChangeJackpot}>
        <CloseIcon />
      </IconButton>
      <h3>Изменить джекпот</h3>
      {loadError ? <JackpotError error={loadError} /> : loading || !jackpot ? (
        <Preloader />
      ) : (
        <JackpotForm
          onSubmit={async (data, hideForm) => {
            try {
              await changeJackpot({ id: jackpotId, data }).unwrap()
              hideForm()
            } catch { /* The mutation error is displayed by the form. */ }
          }}
          error={getJackpotErrors(error)}
          loading={saving}
          cancelBtnEvent={hideChangeJackpot}
          cancelBtnText={'Отмена'}
          submitBtnText={'Изменить'}
          hideForm={hideChangeJackpot}
          jackpotHalls={jackpot.halls}
          jackpotTables={jackpot.gambling_tables}
          id={jackpot.id}
          type={jackpot.type}
          min_bet={jackpot.min_bet}
          min_bet_to_win={jackpot.min_bet_to_win}
          start_balance={jackpot.start_balance}
          restart={jackpot.restart}
          min_players={jackpot.min_players}
          initial_balance={jackpot.initial_balance}
          end_balance={jackpot.end_balance}
          percent={jackpot.percent}
          parent_id={jackpot.parent_id}
          status={jackpot.status}
          hall_id={hall_id}
          table_id={table_id}
          showHall={userRole==='administrator'}
        />
      )}
    </Wrapper>
  )
}

export default ChangeJackpot
